<template>
  <div style="margin-top: 5px" id="target" v-if="isValidUser">
    <div class="form-row">
      <h3>Historical</h3>
    </div>
    <ejs-grid
      :dataSource="accountingHistoricalInvoices"
      ref="refAccountingClosedInvoicesGrid"
      :created="created"
      :allowSorting="true"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :toolbar="toolbarOptions"
      :toolbarClick="toolbarClick"
      :commandClick="cmdClosedInvoiceClick"
      :rowDataBound="rowInvoiceDataBound"
      :allowTextWrap="true"
      :textWrapSettings="wrapSettings"
      :excelQueryCellInfo="excelQueryCellInfo"
      :allowExcelExport="true"
      :sortSettings="sortOptions"
        :queryCellInfo="queryCellInfo"
    >
      <e-columns>
        <!-- header text is used to indicated invoice status, if changing update accordingly -->
        <e-column field="invoiceNumber" headerText="Invoice #" textAlign="Left" width="140" />
        <e-column
          field="invoiceDate"
          headerText="Invoice Date"
          textAlign="center"
          width="140"
          type="date"
          :format="gridDateFormat"
        />
        <e-column
          field="totalAmount"
          headerText="Invoice Amount"
          textAlign="center"
          width="140"
          format="C2"
        />
        <e-column
          field="totalLevy"
          headerText="Levy Amount"
          textAlign="center"
          width="140"
          format="C2"
        />
        <e-column
          field="invoiceAmount"
          headerText="Total invoice"
          textAlign="center"
          width="140"
          format="C2"
        />
        <e-column
          field="refundAmount"
          headerText="Refund Amount"
          textAlign="Left"
          width="160"
          format="C2"
        />
        <e-column
          field="invoiceStatus"
          headerText="Invoice Status"
          width="140" />
        <e-column
          field="requestType"
          headerText="Application Type"
          textAlign="Left"
          width="240"
          clipMode="EllipsisWithTooltip"/>
        <e-column
            field="internalNotes"
            headerText="Internal Comments"
            textAlign="Left"
            width="150"
            clipMode="EllipsisWithTooltip"/>
        <e-column
          field="requestor"
          headerText="Applicant Name"
          textAlign="Left"
          width="160"
          clipMode="EllipsisWithTooltip"/>
        <e-column
          field="requestUserEmail"
          headerText="Applicant Email"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="company"
          headerText="Applicant Company"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column field="siteOwner" headerText="Site Owner" textAlign="Left" width="200" />
        <e-column field="siteId" headerText="Site Number" textAlign="Left" width="200" />
        <e-column
          field="siteAddress"
          headerText="Site Address"
          textAlign="Left"
          width="200"
          clipMode="EllipsisWithTooltip"
        />
        <e-column field="paymentMethod" headerText="Payment Method" textAlign="Left" width="160" />
        <e-column field="paymentType" headerText="Payment Type" textAlign="Left" width="140" />
  <!-- <e-column field="applicationRequestRequestId" headerText="" textAlign="Left" width="0" /> -->

           <e-column field="referencePO" headerText="Reference/PO #" textAlign="Left" width="160" />
          <e-column
            field="transactionNumber"
            headerText="Transaction #"
            textAlign="Left"
            width="180"
          />
          <e-column
            type="date"
          :format="gridDateFormat"
            field="transactionUpdateDate"
            headerText="Transaction Date"
            textAlign="Left"
            width="140"
          />
          <e-column
            field="transactionUpdateUser"
            headerText="Transaction Update User"
            textAlign="Left"
            width="180"
            clipMode="EllipsisWithTooltip"
          />
           <e-column
          type="date"
          field="cancelledRefundMetDate"
          headerText="Cancel/Refund/WO Date"
          textAlign="Left"
          :format="gridDateFormat"
          width="180"
        />
        <e-column
          field="refundReason"
          headerText="Cancel/Refund/WO Reason"
          textAlign="Left"
          width="180"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          field="cancelledRefundMetBy"
          headerText="Cancel/Refund/WO by User"
          textAlign="Left"
          width="180"
          clipMode="EllipsisWithTooltip"
        />
        <e-column
          type="date"
          :format="gridDateFormat"
          field="lastUpdatedDate"
          headerText="Date of Update"
          textAlign="Left"
          width="160"
        />
        <e-column headerText="Invoices" :commands="commands" textAlign="center" width="120" />
        <e-column headerText="Receipts" :commands="commands2" textAlign="center" width="120" />
        <e-column
          headerText="Refund Receipts"
          :commands="commands3"
          textAlign="center"
          width="120"
        />
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { tokenStorage } from '@/shared/storage-service';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getInvoicePDF, getDocumentFile, getReceiptPDF } from '../services/accounting-api';
// import { getReceiptPDF } from '../services/receipt-api';
// eslint-disable-next-line import/extensions
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js';

Vue.use(GridPlugin);

export default {
  name: 'AccountingHistoricalInvoice',
  props: {
    isValidUser: Boolean,
  },
  data() {
    return {
      actionableColumnHeaders: { invoiceNumber: 'Invoice #' },
      invoiceStatuses: {
        cancelled: 'Cancelled', paid: 'Paid', refund: 'Paid (Refund)', wo: 'Cancelled-WO',
      },
      commands: [
        {
          type: 'View Invoice',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands2: [
        {
          type: 'View Receipt',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      commands3: [
        {
          type: 'Refund Receipt',
          buttonOption: {
            cssClass: 'e-flat viewpdfbtn',
            iconCss: 'e-export-pdf e-icons',
          },
        },
      ],
      sortOptions: {
        columns: [{ field: 'transactionUpdateDate', direction: 'Descending' }],
      },
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 10 },
      target: '#target',
      wrapSettings: { wrapMode: 'Header' },
      gridDateFormat: getDataGridDateFormat(),
    };
  },
  computed: {
    ...mapGetters({
      accountingHistoricalInvoices: 'accountingHistoricalInvoices',
      loggedUser: 'loggedUser',
    }),
    loggedUserId() {
      return this.loggedUser?.id;
    },
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.refAccountingClosedInvoicesGrid) {
        document
          .getElementById(`${this.$refs.refAccountingClosedInvoicesGrid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.refAccountingClosedInvoicesGrid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    rowInvoiceDataBound(args) {
      if (args.data.invoiceStatus === 'Cancelled-WO'
      || args.data.paymentStatus === 'Cancelled') {
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll('.e-unboundcelldiv')[1]
          .querySelectorAll('button')[0].style.display = 'none';
      }
      if (args.data.refundDocumentId === null) {
        // eslint-disable-next-line no-param-reassign
        args.row
          .querySelectorAll('.e-unboundcelldiv')[2]
          .querySelectorAll('button')[0].style.display = 'none';
      }
    },
    async cmdClosedInvoiceClick(args) {
      const invoice = args.rowData;
      const { invoiceId, orderNumber, refundDocumentId } = invoice;
      // eslint-disable-next-line default-case
      const accessToken = tokenStorage.getAccessToken();
      switch (args.commandColumn.type) {
        case 'View Invoice':
          // eslint-disable-next-line no-case-declarations
          await getInvoicePDF(accessToken, this.loggedUserId, invoiceId).then(
            (res) => {
              window.location.href = `${res.config.baseURL}${res.config.url}`;
            },
          );
          break;
        case 'View Receipt':
          // eslint-disable-next-line no-case-declarations
          if (orderNumber !== null && orderNumber !== undefined && orderNumber !== '') {
            await getReceiptPDF(accessToken, this.loggedUserId, orderNumber, invoiceId).then(
              (res) => {
                window.location.href = `${res.config.baseURL}${res.config.url}`;
              },
            );
          }
          break;
        case 'Refund Receipt':
          // eslint-disable-next-line no-case-declarations
          if (
            refundDocumentId !== null
            && refundDocumentId !== undefined
            && refundDocumentId !== ''
          ) {
            await getDocumentFile(accessToken, this.loggedUserId, refundDocumentId).then((res) => {
              window.location.href = `${res.config.baseURL}${res.config.url}`;
            });
          }
          break;
        default:
          break;
      }
    },
    // (args) {
    //   if (args.column.field === 'invoiceDate') {
    //     let invoiceDate = new Date(Date.parse(args.value));
    //     invoiceDate = invoiceDate.toLocaleString('default', {
    //       day: 'numeric',
    //       month: 'long',
    //       year: 'numeric',
    //     });
    //     // eslint-disable-next-line no-param-reassign
    //     args.value = invoiceDate;
    //   }
    //   if (args.column.field === 'cancelledRefundMetDate') {
    //     let refundMetDateexcelQueryCellInfo = new Date(Date.parse(args.value));
    //     refundMetDate = refundMetDate.toLocaleString('default', {
    //       day: 'numeric',
    //       month: 'long',
    //       year: 'numeric',
    //     });
    //     // eslint-disable-next-line no-param-reassign
    //     args.value = refundMetDate;
    //   }
    // },
    queryCellInfo(args) {
      this.colorCodeInvoiceNumberByStatus(
        args.column?.headerText,
        args.cell,
        args.data,
      );
    },
    colorCodeInvoiceNumberByStatus(colHeader, cell, invoice) {
      if (colHeader === this.actionableColumnHeaders.invoiceNumber) {
        if (invoice.invoiceStatus === this.invoiceStatuses.cancelled
        || invoice.invoiceStatus === this.invoiceStatuses.wo) {
          // eslint-disable-next-line no-param-reassign
          cell.className += ' status-cancel';
        } else if (invoice.invoiceStatus === this.invoiceStatuses.refund) {
          // eslint-disable-next-line no-param-reassign
          cell.className += ' status-refund';
        } else if (invoice.invoiceStatus === this.invoiceStatuses.paid) {
          // eslint-disable-next-line no-param-reassign
          cell.className += ' status-paid';
        }
      }
    },
    excelQueryCellInfo(args) {
      // eslint-disable-next-line default-case
      switch (args.column.field) {
        case 'invoiceDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'transactionUpdateDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'cancelledRefundMetDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
        case 'lastUpdatedDate':
          // eslint-disable-next-line no-param-reassign
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.refAccountingClosedInvoicesGrid.excelExport({
            fileName: reportExportFileName('Historical Invoices.xlsx'),
          });
          break;
      }
    },
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
};
</script>

<style>

.status-cancel {
   color: rgb(128, 127, 126) !important;
}
td.status-cancel::before,td.status-paid::before,td.status-refund::before {
    content: "..";
    margin-right: 10px;
    color: transparent;
}
td.status-refund::before {
    background: #ff5e00;
}
td.status-paid::before {
    background: rgb(4, 206, 4);
}
td.status-cancel::before {
  background: gray;
}
</style>
